import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterRecargaCredito from 'views/cash/recargacredito/filterRecargaCredito'; // Importing filter component
import RecargaCredito from 'views/cash/recargacredito/RecargaCredito'; // Importing credit recharge component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for recharging credit.
 * @extends JetView
 */
export default class recargarCreditoView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        const left = {
            // Left panel configuration
            css: 'int-left',
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // Back button configuration
                            view: 'button',
                            type: 'icon',
                            icon: 'wxi-angle-left',
                            id: 'back-button',
                            align: 'center',
                            click: () => {
                                // Click event for back button
                                $$('FilterRecargaCredito').show(); // Show filter component
                                $$('FilterRecargaCredito').clear(); // Clear filter component
                                $$('formRecargaCredito').hide(); // Hide form component
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Recargar Credito') }, // Label for the title
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon configuration
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                FilterRecargaCredito, // Including filter component
                RecargaCredito, // Including credit recharge component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left panel in the layout
                },
            ],
        };
    }

    /**
     * Initializes the view components.
     */
    init() {
        $$('back-button').hide(); // Initially hide the back button
    }
}

// FILE DOCUMENTED
